<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        MAWOP Calculator Form
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>
<hr class="my-0" />

<mat-dialog-content class="px-0">
    <form [formGroup]="form" class="grid grid-cols-3 gap-2 my-2">
        <div>
            <mat-label> Casing </mat-label>
            <mat-form-field class="custom-mat-form-field w-full">
                <input type="text" matInput formControlName="casing" readonly />
            </mat-form-field>
        </div>
        <div>
            <mat-label>MIYP</mat-label>
            <mat-form-field class="custom-mat-form-field w-full">
                <input matInput formControlName="miyp" />
                <span matTextSuffix>psi</span>
            </mat-form-field>
        </div>

        <div>
            <mat-label>MCP</mat-label>
            <mat-form-field class="custom-mat-form-field w-full">
                <input matInput formControlName="mcp" />
                <span matTextSuffix>psi</span>
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-outline btn-error mr-2" mat-dialog-close>
        Cancel
    </button>
    <button class="btn btn-error text-white  mr-2" *ngIf="enableDelete()" (click)="delete()">
        Delete
    </button>
    <button class="btn btn-primary" (click)="save()" [disabled]="disabledSave()">Save</button>
</mat-dialog-actions>

<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>